import React, { useEffect, useRef, useState } from 'react';

import { AnimatePresence } from 'framer-motion';

import { useOnClickOutside } from '@app/helpers';

import { PopoverArrow, PopoverBox, PopoverText, PopoverTitle, PopoverWrapper } from './styles';

type PopooverPositions = 'top-left' | 'top-right';

interface PopoverProps {
    title: string;
    text: string;
    localStorageKey: string;
    position?: PopooverPositions;
    positionArrow?: PopooverPositions;
}

export const Popover = ({
    title,
    text,
    localStorageKey,
    position = 'top-left',
    positionArrow = 'top-left',
}: PopoverProps) => {
    const [show, setShow] = useState(false);
    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const seenPrompt = localStorage.getItem(localStorageKey);

        if (!seenPrompt) {
            setShow(true);
        }
    }, [localStorageKey]);

    const onClick = () => {
        setShow(false);
        localStorage.setItem(localStorageKey, '1');
    };

    useOnClickOutside(divRef, () => {
        setShow(false);
        localStorage.setItem(localStorageKey, '1');
    });

    return (
        <div ref={divRef}>
            <AnimatePresence>
                {show && (
                    <PopoverWrapper
                        initial={{ opacity: 0, y: 60 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0 }}
                        transition={{ bounce: 0 }}
                        onClick={onClick}
                        $position={position}
                    >
                        <PopoverArrow $position={positionArrow} />
                        <PopoverBox>
                            <PopoverTitle>{title}</PopoverTitle>
                            <PopoverText>{text}</PopoverText>
                        </PopoverBox>
                    </PopoverWrapper>
                )}
            </AnimatePresence>
        </div>
    );
};
